export const DEFAULT_PIXEL_HEIGHT = 10;
export const ASCII_START = 32; // Space character
export const ASCII_END = 126; // Tilde (~) character
export const MIN_PIXEL_HEIGHT = 1;
